module.exports = __webpack_public_path__ + "static/media/51.29acdc48.png";